import {HttpInterceptorFn} from '@angular/common/http';
import {AppProvider} from '@env/provider-config';
import {environment} from 'src/environments/environment';

const VALID_PROVIDERS: readonly AppProvider[] = ['audax', 'o2'];

/**
 * Envía X-Ch-Provider en llamadas al API del core.
 * El gateway puede inyectarla también por ruta (/audax|/o2); esto cubre ambos caminos.
 *
 * Solo se envía a la propia apiUrl y solo con un proveedor conocido: si el valor no es
 * válido, la petición sale sin cabecera y el core aplica su proveedor por defecto.
 */
export const providerInterceptor: HttpInterceptorFn = (req, next) => {
	const apiUrl = environment.apiUrl;
	const provider = environment.provider;

	if (!apiUrl || !req.url.startsWith(apiUrl) || !VALID_PROVIDERS.includes(provider)) {
		return next(req);
	}

	return next(
		req.clone({
			setHeaders: {
				'X-Ch-Provider': provider,
			},
		}),
	);
};
